import React from 'react';
import { IndexRedirect, Route } from 'react-router';

import BudgetSettings from '../BudgetSettings';
import BudgetGroupAddOrEdit from '../BudgetGroupAddOrEdit';
import BudgetItemAddOrEdit from '../BudgetItemAddOrEdit';
import BudgetItemView from '../BudgetItemView';
import BudgetPaymentAddOrEdit from '../BudgetPaymentAddOrEdit';
import BudgetItemAddVendor from '../BudgetItemAddVendor';
import BudgetItemPaymentQuickView from '../BudgetItemPaymentQuickView';

export const BUDGET_BASE_ROUTE = '/wedding/manage/budget';

const getBudgetRoutes = (): JSX.Element | null => {
  return (
    <Route
      path="budget"
      getComponent={(location, callback) => {
        require.ensure(
          [],
          require => {
            callback(null, require('../Budget').default);
          },
          'Budget'
        );
      }}
    >
      <Route path="settings" component={BudgetSettings} />
      <Route path="group">
        <IndexRedirect to="new" />
        <Route path="new" component={BudgetGroupAddOrEdit} />
        <Route path=":taxonomyNodeUuid" component={BudgetGroupAddOrEdit} />
      </Route>
      <Route path="item">
        <IndexRedirect to="new" />
        <Route path="new" component={BudgetItemAddOrEdit} />
        <Route path=":itemUuid" component={BudgetItemView} />
        <Route path=":itemUuid/edit" component={BudgetItemAddOrEdit} />
        <Route path=":itemUuid/add-vendor" component={BudgetItemAddVendor} />
        <Route path=":itemUuid/payment">
          <IndexRedirect to="new" />
          <Route path="new" component={BudgetPaymentAddOrEdit} />
          <Route path=":paymentUuid" component={BudgetPaymentAddOrEdit} />
        </Route>
        <Route
          path=":itemUuid/payment/:paymentUuid/quick-view"
          component={BudgetItemPaymentQuickView}
        />
      </Route>
    </Route>
  );
};

export default getBudgetRoutes;
export { default as useLeaveBudgetRoute } from './useLeaveBudgetRoute';
export { default as handleBudgetRouteChange } from './handleBudgetRouteChange';
